import React, { useEffect, useState } from 'react'
import request from 'meinian-package/src/utils/request'
import Select from 'meinian-package/src/baseComponent/select'

const convert = (result) => {
  return result.map(m => ({ label: m.nickName, value: m.userId }))
}
export default (props) => {
  const { missionId, placement, placeholder = '采集成员', ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchUsers()
  }, [missionId])
  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/blog/mission/mission-blog-user-selector', { params: { missionId } })
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select placement={placement} multi {...otherProps} data={options} placeholder={placeholder} />
}
